import React, { Fragment }   from "react";
import { List,
    Datagrid,DeleteButton
} from 'react-admin';
import FieldGuesser from 'UI/Common/ApiPlateform/FieldGuesser';
import {FilterFinal} from "./Filter";
import {useResourceOptions} from "../../hooks";
import {DefaultListProps} from "../Common/DefaultListProps";

export const ListPlain = ({...props }) => {
    const { readableFields, operations } = useResourceOptions(props.resource);
    if(!operations || !operations.list) return null;
    return (
        <Fragment>
            <List  filters={<FilterFinal readableFields={readableFields}/>} {...DefaultListProps({operations})} {...props}>
                <Datagrid>
                    {<FieldGuesser  source={'productId'}/>}
                    {<FieldGuesser  source={'ID'}/>}
                    {<FieldGuesser  source={'title'}/>}
                    {<FieldGuesser  source={'brand'}/>}
                    {<FieldGuesser  source={'stock'}/>}
                    {<FieldGuesser  source={'salePrice'}/>}
                    <DeleteButton undoable={false}/>
                </Datagrid>
            </List>
        </Fragment>
    );
};

export const ListFinal = ListPlain;
